import './DollarValueFixed.css'
import { useContext } from "react"
import AppContext from "../../contexts/AppContext"
import { Card, Flex, Stack } from "@mantine/core"
import { IconCurrencyDollar } from "@tabler/icons-react"


export default function DollarValueFixed() {
    const { dollarValue } = useContext(AppContext)

    return (
        <div
            className="DollarValueFixed-main-container"
        >
            <Stack gap={0} align='center'>
                <span>Valor dólar</span>
                <Flex
                    align='center'
                    classNames={{ root: "DollarValueFixed-content-wrapper" }}
                >
                    <IconCurrencyDollar />
                    <span style={{
                        fontSize: "var(--fs-body)",
                    }}>{dollarValue}</span>
                </Flex>
            </Stack>
        </div>
    )
}